import React, { useState, useEffect } from 'react'
import { Modal, message } from 'antd'
import * as UTILS from '../../../utils'
import './index.less'

export type FileType = '图片' | '文章' | '视频' | '音频';

export interface PreviewInfo {
	content: string; // 文件链接或html字符串
	type: FileType;
	title?: string; // 文章标题
	author?: string; // 文章作者
}

export interface FilePreviewProps {
	visible: boolean;
	handleVisible: (val: boolean) => void;
	content: string; // 文件链接或html字符串
	type: FileType;
	title?: string; // 文章标题
	author?: string; // 文章作者
}

const FilePreview: React.FC<FilePreviewProps> = ({
	visible,
	handleVisible,
	content,
	type,
	title,
	author,
}) => {
	let audio = null
	let video = null
	const [isValid, setIsValid] = useState<boolean>(true) // 是否支持预览

	useEffect(() => {
		console.log(type)
		if (!['图片', '文章', '视频', '音频','URL','文件'].includes(type)) {
			message.warning('当前文件类型暂不支持预览')
			setIsValid(false)
			return
		}
		if (type === '视频' && !['mp4', 'webm', 'ogg'].includes(UTILS.getFileExtension(content))) {
			message.warning('仅支持预览mp4、webm、ogg格式的视频文件')
			setIsValid(false)
			return
		}
		if (type === '音频' && !['mp3', 'wav', 'ogg'].includes(UTILS.getFileExtension(content))) {
			message.warning('仅支持预览mp3、wav、ogg格式的音频文件')
			setIsValid(false)
			return
		}
		setIsValid(true)
	}, [content, type])

	useEffect(() => {
		if (visible) return
		video && video.pause()
		audio && audio.pause()
		// 文章中可能包含音视频 关闭弹窗时有需要暂停
		const pauseMedia = (medias) => {
			if (medias.length) {
				for (let i = 0; i < medias.length; i++) {
					medias[i].pause()
				}
			}
		}
		const videos = document.getElementsByTagName('video')
		const audios = document.getElementsByTagName('audio')
		pauseMedia(videos)
		pauseMedia(audios)
	}, [visible])

	const handleModalVisible = (val: boolean) => {
		handleVisible(val)
	}

	const handleCancel = () => {
		handleModalVisible(false)
	}

	const renderContent = (type: FileType, content: any) => {
		if (!content) return ''
		const renderImg = () => <img src={content} alt={content}/>
		const renderVideo = () => <video ref={(ref)=>{video = ref}} src={content} controls autoPlay></video>
		const renderAudio = () => <audio ref={(ref)=>{audio = ref}} src={content} controls autoPlay></audio>
		const renderText = () => (<>
			{(title || author) && <div className="preview-info-article">
				<h1>{title}</h1>
				<p>{author}</p>
			</div>}
			<div className="preview-content" dangerouslySetInnerHTML={{__html: UTILS.HTMLDecode(content)}} ></div>
		</>)
		const renderIframe= () => (
			<iframe  style={{margin: '20px auto', border: 0, width: '375px', display: 'block', height: '667px'}} src={content}></iframe>
		)
		const renderFile= () => (
			content.includes('png')||content.includes('jpeg')||content.includes('jpg')?<img src={content} alt={content}/>:content.includes('mp4')||content.includes('MP4')?<video ref={(ref)=>{video = ref}} src={content} controls autoPlay></video>:<a href={content} style={{display: 'block'}}>文件链接，点击预览</a>
		)
		const funcMap = {
			'图片': renderImg(),
			'视频': renderVideo(),
			'音频': renderAudio(),
			'文章': renderText(),
			'URL': renderIframe(),
			'文件': renderFile()
		}
		return funcMap[type]
	}

	return (
		isValid && <Modal
			className={type === '文章' ? 'text-preview-wrapper' : 'media-preview-wrapper'}
			visible={visible}
			onCancel={handleCancel}
			footer={null}
			centered
		>
			{
				Array.isArray(content) ? content.map(item => renderContent(type, item)) : renderContent(type, content)
			}
		</Modal>
	)
}

export default FilePreview
